import { marqueeItems } from "@/mocks/site";

export default function Marquee() {
  return (
    <section
      aria-label="Sunulan görüntüleme yöntemleri"
      className="overflow-hidden border-y border-accent-600/40 bg-accent-500 py-4"
    >
      <div className="marquee-track flex w-max">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1}>
            {marqueeItems.map((item) => (
              <span
                key={`${copy}-${item}`}
                className="flex items-center gap-4 whitespace-nowrap px-5 text-xs font-semibold uppercase tracking-[0.18em] text-foreground-950/80"
              >
                <i className="ri-add-line text-foreground-950/50" aria-hidden="true" />
                {item}
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}